<template>
    <v-toolbar>
        <v-container class="pa-0" fill-height fluid>
            <v-row align="center">
                <v-col>
                    <v-autocomplete
                        label="Unit"
                        item-value="id"
                        item-text="number"
                        :items="units"
                        no-filter
                        :loading="isSearchingUnit"
                        :search-input.sync="unitSearch"
                        v-model="selectedUnitId"
                        no-data-text="Start typing a Unit Name or Number"
                        name="unit"
                        autocomplete="off"
                        hide-details
                        :clearable="true"
                    >
                        <template v-slot:item="{ item }">
                            <v-list-item-content>
                                <v-list-item-title>{{ item.number }} ({{ item.garage }})</v-list-item-title>
                                <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col>
                    <v-text-field label="EDN / Incident Number" v-model="selectedEdnNumber" name="edn" :clearable="true" autocomplete="off" hide-details maxlength="30"></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field label="Contains" v-model="freeText" name="freeText" :clearable="true" autocomplete="off" hide-details></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-select :items="dateFieldOptions" label="Date Field" v-model="dateField" hide-details></v-select>
                </v-col>
                <v-col>
                    <v-menu v-model="startDateDialog" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Start Date"
                                readonly
                                v-model="formattedStartDate"
                                name="received date"
                                v-on="on"
                                required
                                append-icon="event"
                                hide-details
                                @click:append="startDateDialog = true"
                                :clearable="true"
                            ></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="startDate" @change="startDateDialog = false" :min="isoMinDate" :max="maxDateOrEndDateMinusOne"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-menu v-model="endDateDialog" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="formattedEndDate" label="End Date" readonly name="end date" v-on="on" required append-icon="event" hide-details @click:append="endDateDialog = true" :clearable="true"></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="endDate" @change="endDateDialog = false" :min="minDateOrStartDatePlusOne" :max="isoMaxDate"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col class="shrink">
                    <v-btn text icon @click.native="triggerSearch">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </v-col>
                <v-col class="shrink pr-0 pl-1">
                    <v-btn text icon @click.native="clearSearch">
                        <v-icon>clear</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-toolbar>
</template>

<script>
import { Event, EventBus } from '@/plugins/bus';
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';

export default {
    params: {
        value: {
            required: true
        }
    },
    data() {
        return {
            isSearchingUnit: false,
            units: [],
            unitSearch: null,
            startDateDialog: false,
            dateField: '',
            endDateDialog: false,
            selectedUnitId: null,
            selectedEdnNumber: null,
            freeText: null,
            startDate: null,
            endDate: null,
            dateFieldOptions: ['Received', 'Scheduled']
        };
    },
    computed: {
        formattedStartDate: {
            get() {
                return this.startDate ? moment(this.startDate).format(DateFormat.DefaultDisplay) : '';
            },
            set() {
                //set when clearing
                this.startDate = null;
            }
        },
        formattedEndDate: {
            get() {
                return this.endDate ? moment(this.endDate).format(DateFormat.DefaultDisplay) : '';
            },
            set() {
                //set when clearing
                this.endDate = null;
            }
        },
        isoMinDate() {
            return moment('1900-01-01').format(DateFormat.Canonical);
        },
        isoMaxDate() {
            return moment('3999-01-01').format(DateFormat.Canonical);
        },
        minDateOrStartDatePlusOne() {
            return this.startDate
                ? moment(this.startDate)
                      .add(1, 'day')
                      .format(DateFormat.Canonical)
                : this.isoMinDate;
        },
        maxDateOrEndDateMinusOne() {
            return this.endDate
                ? moment(this.endDate)
                      .subtract(1, 'hour')
                      .format(DateFormat.Canonical)
                : this.isoMaxDate;
        }
    },
    watch: {
        async unitSearch(val) {
            this.performSearch(val, this);
        }
    },
    methods: {
        triggerSearch() {
            var searchData = {
                unitId: this.selectedUnitId,
                ednNumber: this.selectedEdnNumber,
                freeText: this.freeText,
                dateField: this.dateField,
                startDate: this.startDate,
                endDate: this.endDate
            };
            this.$emit('input', searchData);
            this.$emit('searching');
        },
        clearSearch() {
            this.selectedUnitId = null;
            this.selectedEdnNumber = null;
            this.freeText = null;
            this.dateField = '';
            this.startDate = null;
            this.endDate = null;
            this.units = [];
            this.triggerSearch();
            this.$emit('closesearch');
        },
        performSearch: _.debounce(async (val, me) => {
            if (!me.unitSearch) {
                me.unitSearch = me.selectedUnit ? me.selectedUnit.name : '';
            }
            if (!me.unitSearch) {
                return;
            }

            try {
                me.isSearchingUnit = true;
                const response = await me.$api.get(`units?searchTerm=${me.unitSearch}&unitType='both'&orderByUnitMatch=true`);
                me.units = response.data.data;
            } catch {
                me.$toast.error('There was an error getting units');
            }
            me.isSearchingUnit = false;
        }, 200)
    }
};
</script>

<style lang="scss" scoped>
.v-menu.v-menu--inline {
    display: inline !important;
}
</style>
